import React from 'react';
import PropTypes from 'prop-types';
import { FormattedPlural } from 'react-intl';
import { Link } from 'react-router';
import { statusColours } from '../../constants/ColourConstants';

import ROLES from '../../constants/Roles';
import ContextIconMenu from '../Common/ContextIconMenu';
import { ListItem } from 'material-ui/List';

import DefaultIcon from 'material-ui/svg-icons/navigation/check';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import InfoIcon from 'material-ui/svg-icons/action/info';
import IconOrganisation from 'material-ui/svg-icons/social/domain';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import OrganisationActions from '../../actions/OrganisationActionCreator';


const style = {
    listItem: {
        padding: '2px'
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};


const getActions = (row, isRootAdmin) => [
    {
        link: `/dashboard/organisation/${row.id}`,
        label: 'Preview',
        icon: <InfoIcon />
    },
    {
        type:'divider'
    },
    {
        link: `/dashboard/organisation/${row.id}/edit`,
        label: 'Edit',
        icon: <EditIcon />,
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        action: () => OrganisationActions.setDefault(row.id),
        label: 'Set default',
        icon: <DefaultIcon />,
        condition: {
            show: (!row.isDefault && isRootAdmin)
        }
    },
    {
        link: `/dashboard/organisation/${row.id}/settings`,
        icon: <SettingsIcon />,
        label: 'Settings',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: row.id,
        title: 'Delete organisation',
        deleteAction: OrganisationActions.delete,
        message: (<span>Are you sure to delete the organisation  "{row.name}" ?</span>),
        condition: {
            show:  row.sysStatus > 4,
            roles: [ROLES.ADMIN]
        }
    }
];

const OrganisationListItem = ({data, onDelete, actions}, {auth}) => {

    const infoLink = `/dashboard/organisation/${data.id}`;
    const spot = !!data.isDefault && (<span className="spot" title="default"/>);

    const listItemProps = {
        style: style.listItem,
        primaryText: (<Link to={infoLink} className="primaryText">{data.name}{spot}</Link>),
        secondaryTextLines: 2
    };

    let departments;
    if (data.departmentCount) {
        departments = (<span>{data.departmentCount}&nbsp;<FormattedPlural value={data.departmentCount} one='department' other='departments' /></span>);
    }

    let flags = [];
    if (!data.isPublic) {
        flags.push(<span key="a" className="flag-text">private</span>);
    }

    listItemProps.secondaryText = (
        <Link to={infoLink} className="secondaryText">
            {flags}{data.description} <br />
            {departments}
        </Link>
    );

    const actionList = (actions || getActions(data, auth.isRootAdmin()));
    if (!!actionList && actionList.length > 0) {
        listItemProps.rightIcon = (<ContextIconMenu actions={actionList} data={data} />);
    }

    return (
        <ListItem
            leftAvatar={
                <Link to={infoLink}>
                    <IconOrganisation
                        color={data.enabled ? statusColours.primary : statusColours.disabled}
                        style={style.icon}
                    />
                </Link>
            }


            {...listItemProps} />
    );
};

OrganisationListItem.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        isDefault: PropTypes.bool,
        departmentCount: PropTypes.number,
    }).isRequired,
    actions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    onDelete: PropTypes.func
};

OrganisationListItem.contextTypes = {
    auth: PropTypes.object
};

export default OrganisationListItem;
